import { FC } from 'react';
import { Skeleton, Box, SxProps } from '@mui/material';

interface CardLoaderProps {
  sx?: SxProps;
}

export const CardLoader: FC<CardLoaderProps> = ({ sx }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, ...sx }}>
      <Skeleton variant="text" sx={{ fontSize: '1.5rem' }} width="60%" />
      <Skeleton variant="text" sx={{ fontSize: '1rem' }} width="40%" />
      <Box sx={{ mt: 1 }}>
        <Skeleton variant="text" width="100%" />
        <Skeleton variant="text" width="85%" />
        <Skeleton variant="text" width="70%" />
      </Box>
    </Box>
  );
};
